/* @flow */
import React from 'react';
// $FlowIgnore
import { MdArrowDropDown } from 'react-icons/md';

export default function ArrowDownIcon({
  style
}: Object): React.Element {
  return <MdArrowDropDown style={style} />;
}
